import { ExpandIcon } from "assets/icons/ExpandIcon";
import { ImageIcon } from "assets/icons/ImageIcon";
import { IconButton } from "components/IconButton/IconButton";
import { DocumentacionAdjuntaI } from "dtos/documentacionAdjunta";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { NormativaI } from "interfaces/Normativa";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { getDocumentacionFile, openFile } from "services/normativas";

interface Props {
  onClose?: any;
  elemento: DiseñoCurricularI | null;
  showModal: boolean;
}
const onClickVerDocumento = (id: string | number, name: string, fileName: string) => {
  window.open(`/visor-pdf/${name}?id=${id}&fileName=${encodeURIComponent(fileName)}`, "_blank");
};

const shortenFileName = (fileName: string, maxLength: number) => {
  if (fileName.length <= maxLength) return fileName;

  const extension = fileName.split(".").pop();
  if (!extension) return fileName;
  const nameWithoutExtension = fileName.slice(0, -(extension?.length + 1));

  const shortenedName = nameWithoutExtension.slice(
    0,
    maxLength - (extension?.length + 4),
  );

  return `${shortenedName}...${extension}`;
};

export const DiseniosCurricularesDetailModal = ({
  elemento,
  showModal,
  onClose,
}: Props) => {
  const [fullElement, setFullElement] = useState<ValidezNacionalI>();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (showModal) {
      // Lógica para cargar datos si es necesario
    }
  }, [showModal]);

  return (
    <Modal show={showModal} onHide={onClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>{"Documentación Adjunta:"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col>
          <Row>
            {elemento?.documentacionAdjunta && (
              <Col lg={12}>
                <b>Documento Oficial:</b> <br />
                {elemento.documentacionAdjunta.map(
                  (anexo: DocumentacionAdjuntaI, index) => (
                    <div className="input-file-selected" key={index}>
                      <ImageIcon size={22} />
                      <p className="title">
                        {shortenFileName(anexo.nombre_real ? anexo.nombre_real : anexo.nombre, 40)}
                      </p>
                      <IconButton onClick={() => onClickVerDocumento(anexo.id, anexo.nombre, anexo.nombre_real ? anexo.nombre_real : anexo.nombre)}>
                        {" "}
                        <ExpandIcon size={23} />
                      </IconButton>
                    </div>
                  ),
                )}
              </Col>
            )}
          </Row>
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="mx-3"
          variant="secondary"
          size="lg"
          onClick={onClose}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
